import type * as React from 'react';
import type { ISVGIconProps } from '@cian/ui-kit-design-tokens/internal';
import {
  IconComfortElecticity16,
  IconInfrastructureBike16,
  IconInfrastructureForest16,
  IconInfrastructureHospital16,
  IconInfrastructureKid16,
  IconInfrastructureParking16,
  IconInfrastructurePolice16,
  IconInfrastructureRestaurant16,
  IconInfrastructureSchool16,
  IconInfrastructureScooter16,
  IconInfrastructureStore16,
  IconMapBus16,
  IconMapCar16,
  IconMapMetroMsk16,
  IconMapNoCar16,
  IconMapStreetcar16,
} from '@cian/ui-kit-design-tokens/icons';

import {
  TInfrastructurePoiType,
  TTaCategory,
  TTaInsideCategory,
  TTaOutsideCategory,
  TTaTab,
} from '../../types/infrastructure';

export const INFRASTRUCTURE_ICON_MAP: Record<TInfrastructurePoiType, React.FunctionComponent<ISVGIconProps>> = {
  cafe: IconInfrastructureRestaurant16,
  clinic: IconInfrastructureHospital16,
  grocery: IconInfrastructureStore16,
  metro: IconMapMetroMsk16,
  nursery: IconInfrastructureKid16,
  school: IconInfrastructureSchool16,
};

/** Подписи чипсов-фильтров. */
export const INFRASTRUCTURE_TITLE_MAP: Record<TInfrastructurePoiType, string> = {
  cafe: 'Кафе',
  clinic: 'Медицинские учреждения',
  grocery: 'Магазины',
  metro: 'Метро',
  nursery: 'Детские сады',
  school: 'Школы',
};

/** Порядок чипсов по макету; кафе в макете нет — оставляем последним. */
export const INFRASTRUCTURE_POI_TYPES_ORDER: readonly TInfrastructurePoiType[] = [
  'metro',
  'school',
  'nursery',
  'clinic',
  'grocery',
  'cafe',
];

/** Тип, выбранный при открытии карты. */
export const DEFAULT_INFRASTRUCTURE_POI_TYPE: TInfrastructurePoiType = 'metro';

export const TA_ICON_MAP: Record<TTaCategory, React.FunctionComponent<ISVGIconProps>> = {
  busStops: IconMapBus16,
  tramStops: IconMapStreetcar16,
  metro: IconMapMetroMsk16,
  parking: IconInfrastructureParking16,
  bikeParking: IconInfrastructureBike16,
  scooterParking: IconInfrastructureScooter16,
  chargingStations: IconComfortElecticity16,
  yardWithoutCars: IconMapNoCar16,
  boulevards: IconInfrastructureForest16,
  trafficSafetyElements: IconInfrastructurePolice16,
  dropOffPickUpArea: IconMapCar16,
};

export const TA_TITLE_MAP: Record<TTaCategory, string> = {
  busStops: 'Автобусы',
  tramStops: 'Трамваи',
  metro: 'Метро',
  parking: 'Парковки',
  bikeParking: 'Велопарковки',
  scooterParking: 'Парковки самокатов',
  chargingStations: 'Зарядки электромобилей',
  yardWithoutCars: 'Двор без машин',
  boulevards: 'Бульвары',
  trafficSafetyElements: 'Безопасность движения',
  dropOffPickUpArea: 'Место для остановки',
};

export const TA_OUTSIDE_ORDER: readonly TTaOutsideCategory[] = [
  'busStops',
  'tramStops',
  'metro',
  'parking',
  'bikeParking',
  'scooterParking',
  'chargingStations',
];

export const TA_INSIDE_ORDER: readonly TTaInsideCategory[] = [
  'parking',
  'bikeParking',
  'scooterParking',
  'chargingStations',
  'yardWithoutCars',
  'boulevards',
  'trafficSafetyElements',
  'dropOffPickUpArea',
];

export const TA_TAB_TITLES: Record<TTaTab, string> = {
  outside: 'Рядом с ЖК',
  inside: 'Внутри ЖК',
};

/** Зум карты в режиме транспортной доступности (константы map-search). */
export const TA_ZOOM: Record<TTaTab, number> = {
  inside: 17,
  outside: 15,
};

// Линию дороги рисует движок карты, CSS-переменные там не резолвятся — хекс от --accent-positive-primary.
export const FUTURE_ROAD_LINE_HEX = '#227e01';
